//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, watch } from '@vue/composition-api'

export default {
  setup() {
    const date = new Date().toISOString().substr(0, 10)
    const pickerDate = ref(null)
    const notes = ref([])
    const allNotes = [
      'President met with prime minister',
      'New power plant opened',
      'Rocket launch announced',
      'Global warming discussion cancelled',
      'Company changed its location',
    ]

    watch(pickerDate, () => {
      notes.value = [
        allNotes[Math.floor(Math.random() * 5)],
        allNotes[Math.floor(Math.random() * 5)],
        allNotes[Math.floor(Math.random() * 5)],
      ].filter((value, index, self) => self.indexOf(value) === index)
    })

    return {
      date,
      pickerDate,
      notes,
      allNotes,
    }
  },
}
